import { ListItem, ListItemAvatar, ListItemText } from "@mui/material"
import React from "react";
import LinkIcon from '@mui/icons-material/Link';
import DescriptionIcon from '@mui/icons-material/Description';
import ImageIcon from '@mui/icons-material/Image';
import AbcIcon from '@mui/icons-material/Abc';
import { FILE, URL, IMAGE, TEXT, YT } from "components/files/UploadFileForm";
import { colors, colorToText, getTextFromColor } from "colors";
import AttachmentMenu from "./AttachmentMenu";
import FileTypeIcon from "components/files/FileTypeIcon";
import FileMenu from "components/files/FileMenu";

export default function Attachment({
  attachment, 
  color,
  customRemove = null,
}) {

  const renderText = () => {
    switch(attachment.type) {
      case URL.id:
        return attachment.name;
      case FILE.id:
        return attachment.filename;
      case IMAGE.id:
        return attachment.filename;
      case TEXT.id:
        return attachment.name;
      case YT.id:
        return attachment.name;
      default:
        console.warn(`Unkown ${attachment.type}`);
        return "";
    }
  }


  return (
    <ListItem
      data-testclass="attachment-item"
      secondaryAction={
        <FileMenu 
          file={attachment} 
          color={color} 
          isAttachment={true} 
          customRemove={customRemove}
        />
        // <AttachmentMenu attachment={attachment} />
      }
    >
      <ListItemAvatar>
        <FileTypeIcon file={attachment} size={24} />    
      </ListItemAvatar>
      <ListItemText
        primary={renderText()}
        secondary={new Date(attachment.createdAt).toLocaleString()}
        sx={{
          color: color,
          "& .MuiTypography-root": {
            color: color,
          },
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      />
    </ListItem>
  );

}
